import { render, staticRenderFns } from "./Booklet.vue?vue&type=template&id=3d96f992"
import script from "./Booklet.vue?vue&type=script&lang=ts"
export * from "./Booklet.vue?vue&type=script&lang=ts"
import style0 from "./Booklet.vue?vue&type=style&index=0&id=3d96f992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports